import { render, staticRenderFns } from "./SafetyPlanDialog.vue?vue&type=template&id=55715f7f"
import script from "./SafetyPlanDialog.vue?vue&type=script&lang=js"
export * from "./SafetyPlanDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports